import mainStore from "../../store/store";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
const Stepper = () => {
  const navigate = useNavigate();
  const { userBooking, setSelectedRoute, visitedRoutes, selectedRoute } = mainStore();
  const useDisableRefresh = () => {
    useEffect(() => {
      const handleKeyDown = (e) => {
        if (
          e.key === 'F5' ||
          (e.ctrlKey && e.key === 'r') ||
          (e.metaKey && e.key === 'r') // Mac ⌘R
        ) {
          e.preventDefault();
          alert("Page refresh is disabled!");
        }
      };
  
      window.addEventListener('keydown', handleKeyDown);
  
      return () => {
        window.removeEventListener('keydown', handleKeyDown);
      };
    }, []);
  };
  useDisableRefresh();
  const routeTo = (routeTo) => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    if (
      (routeTo === "/cars" && visitedRoutes.includes("car")) ||
      (routeTo === "/car-details" && visitedRoutes.includes("car-details")) ||
      (routeTo === "/booking" && visitedRoutes.includes("booking")) ||
      (routeTo === "/rental-form" && visitedRoutes.includes("rental-form")) ||
      (routeTo === "/extras" && visitedRoutes.includes("extras"))
    ) {
      setSelectedRoute(routeTo);
      navigate(routeTo);
      
    }
  };

  return (
    <>
      <ul class="Stepper cursor-pointer">
        <li
          className={`${visitedRoutes[visitedRoutes.length - 1] == 'car' ? " Fill Current" : (visitedRoutes.includes("car") ? "Fill" : "Active")}`}
          onClick={() => routeTo("/cars")}
        >
          <span>
            <svg width="30" height="30" viewBox="0 0 30 30">
              <path d="M7.5 23.75V25C7.5 25.3542 7.38021 25.651 7.14062 25.8906C6.90104 26.1302 6.60417 26.25 6.25 26.25H5C4.64583 26.25 4.34896 26.1302 4.10938 25.8906C3.86979 25.651 3.75 25.3542 3.75 25V15L6.375 7.5C6.5 7.125 6.72396 6.82292 7.04688 6.59375C7.36979 6.36458 7.72917 6.25 8.125 6.25H21.875C22.2708 6.25 22.6302 6.36458 22.9531 6.59375C23.276 6.82292 23.5 7.125 23.625 7.5L26.25 15V25C26.25 25.3542 26.1302 25.651 25.8906 25.8906C25.651 26.1302 25.3542 26.25 25 26.25H23.75C23.3958 26.25 23.099 26.1302 22.8594 25.8906C22.6198 25.651 22.5 25.3542 22.5 25V23.75H7.5ZM7.25 12.5H22.75L21.4375 8.75H8.5625L7.25 12.5ZM9.375 20C9.89583 20 10.3385 19.8177 10.7031 19.4531C11.0677 19.0885 11.25 18.6458 11.25 18.125C11.25 17.6042 11.0677 17.1615 10.7031 16.7969C10.3385 16.4323 9.89583 16.25 9.375 16.25C8.85417 16.25 8.41146 16.4323 8.04688 16.7969C7.68229 17.1615 7.5 17.6042 7.5 18.125C7.5 18.6458 7.68229 19.0885 8.04688 19.4531C8.41146 19.8177 8.85417 20 9.375 20ZM20.625 20C21.1458 20 21.5885 19.8177 21.9531 19.4531C22.3177 19.0885 22.5 18.6458 22.5 18.125C22.5 17.6042 22.3177 17.1615 21.9531 16.7969C21.5885 16.4323 21.1458 16.25 20.625 16.25C20.1042 16.25 19.6615 16.4323 19.2969 16.7969C18.9323 17.1615 18.75 17.6042 18.75 18.125C18.75 18.6458 18.9323 19.0885 19.2969 19.4531C19.6615 19.8177 20.1042 20 20.625 20Z" />
            </svg>
          </span>

          <h6>Car</h6>
        </li>
        {/* <li
          className={`${
            visitedRoutes.includes("car-details") ? "Fill" : "Active"
          }`}
          onClick={() => routeTo("/car-details")}
        >
          <span>
            <svg width="30" height="30" viewBox="0 0 30 30">
              <path d="M13.75 21.25H16.25L16.625 19.375C16.875 19.2708 17.1094 19.1615 17.3281 19.0469C17.5469 18.9323 17.7708 18.7917 18 18.625L19.8125 19.1875L21.0625 17.0625L19.625 15.8125C19.6667 15.5208 19.6875 15.25 19.6875 15C19.6875 14.75 19.6667 14.4792 19.625 14.1875L21.0625 12.9375L19.8125 10.8125L18 11.375C17.7708 11.2083 17.5469 11.0677 17.3281 10.9531C17.1094 10.8385 16.875 10.7292 16.625 10.625L16.25 8.75H13.75L13.375 10.625C13.125 10.7292 12.8906 10.8385 12.6719 10.9531C12.4531 11.0677 12.2292 11.2083 12 11.375L10.1875 10.8125L8.9375 12.9375L10.375 14.1875C10.3333 14.4792 10.3125 14.75 10.3125 15C10.3125 15.25 10.3333 15.5208 10.375 15.8125L8.9375 17.0625L10.1875 19.1875L12 18.625C12.2292 18.7917 12.4531 18.9323 12.6719 19.0469C12.8906 19.1615 13.125 19.2708 13.375 19.375L13.75 21.25ZM15 17.5C14.3125 17.5 13.724 17.2552 13.2344 16.7656C12.7448 16.276 12.5 15.6875 12.5 15C12.5 14.3125 12.7448 13.724 13.2344 13.2344C13.724 12.7448 14.3125 12.5 15 12.5C15.6875 12.5 16.276 12.7448 16.7656 13.2344C17.2552 13.724 17.5 14.3125 17.5 15C17.5 15.6875 17.2552 16.276 16.7656 16.7656C16.276 17.2552 15.6875 17.5 15 17.5ZM6.25 26.25C5.5625 26.25 4.97396 26.0052 4.48438 25.5156C3.99479 25.026 3.75 24.4375 3.75 23.75V6.25C3.75 5.5625 3.99479 4.97396 4.48438 4.48438C4.97396 3.99479 5.5625 3.75 6.25 3.75H23.75C24.4375 3.75 25.026 3.99479 25.5156 4.48438C26.0052 4.97396 26.25 5.5625 26.25 6.25V23.75C26.25 24.4375 26.0052 25.026 25.5156 25.5156C25.026 26.0052 24.4375 26.25 23.75 26.25H6.25Z"></path>
            </svg>
          </span>
          <h6>Car Details</h6>
        </li> */}
        <li
          className={`${visitedRoutes[visitedRoutes.length - 1] == 'booking' ? " Fill Current" : (visitedRoutes.includes("booking") ? "Fill" : "Active")}`}

          onClick={() => routeTo("/booking")}
        >
          <span>
            <svg width="30" height="30" viewBox="0 0 30 30">
              <path d="M6.25 27.5C5.5625 27.5 4.97396 27.2552 4.48438 26.7656C3.99479 26.276 3.75 25.6875 3.75 25V7.5C3.75 6.8125 3.99479 6.22396 4.48438 5.73437C4.97396 5.24479 5.5625 5 6.25 5H7.5V2.5H10V5H20V2.5H22.5V5H23.75C24.4375 5 25.026 5.24479 25.5156 5.73437C26.0052 6.22396 26.25 6.8125 26.25 7.5V25C26.25 25.6875 26.0052 26.276 25.5156 26.7656C25.026 27.2552 24.4375 27.5 23.75 27.5H6.25ZM6.25 25H23.75V12.5H6.25V25Z" />
            </svg>
          </span>
          <h6>Booking</h6>
        </li>
        <li
          className={`${visitedRoutes[visitedRoutes.length - 1] == 'rental-form' ? " Fill Current" : (visitedRoutes.includes("rental-form") ? "Fill" : "Active")}`}

          onClick={() => routeTo("/rental-form")}
        >
          <span>
          <svg width="30" height="30" viewBox="0 0 1024 1024" class="icon"  version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M670.5 471.7c-7.1-3.1-14.2-5.9-21.4-8.5 49.8-40.3 81.6-101.8 81.6-170.6 0-121-98.4-219.4-219.4-219.4s-219.4 98.4-219.4 219.4c0 68.9 31.9 130.5 81.7 170.7C219.4 519.6 109 667.8 109 841.3h73.1c0-181.5 147.7-329.1 329.1-329.1 45.3 0 89.1 9 130.2 26.7l29.1-67.2zM511.3 146.3c80.7 0 146.3 65.6 146.3 146.3S592 438.9 511.3 438.9 365 373.2 365 292.6s65.6-146.3 146.3-146.3zM612.5 636.5c0 10.2 5.6 19.5 14.6 24.2l128 67.6c4 2.1 8.4 3.2 12.8 3.2s8.8-1.1 12.8-3.2l128-67.6c9-4.8 14.6-14.1 14.6-24.2s-5.6-19.5-14.6-24.2l-128-67.7c-8-4.2-17.6-4.2-25.6 0l-128 67.7c-9 4.7-14.6 14-14.6 24.2z m155.4-36.6l69.3 36.6-69.3 36.6-69.3-36.6 69.3-36.6z" fill="#0F1F3C" /><path d="M767.9 763.4l-147-77.7-25.6 48.5 172.6 91.2 171.9-90.8-25.6-48.5z" fill="#0F1F3C" /><path d="M767.9 851.4l-147-77.6-25.6 48.4 172.6 91.3 171.3-90.6-25.6-48.5z" fill="#0F1F3C" /></svg>
          </span>
          <h6>Customer</h6>
        </li>
        <li
          className={`${visitedRoutes[visitedRoutes.length - 1] == 'extras' ? " Fill Current" : (visitedRoutes.includes("extras") ? "Fill" : "Active")}`}

          onClick={() => routeTo("/extras")}
        >
          <span>
            <svg width="30" height="30" viewBox="0 0 30 30">
              <path d="M11 26.25H6.25C5.5625 26.25 4.97396 26.0052 4.48438 25.5156C3.99479 25.026 3.75 24.4375 3.75 23.75V19C4.75 19 5.625 18.6823 6.375 18.0469C7.125 17.4115 7.5 16.6042 7.5 15.625C7.5 14.6458 7.125 13.8385 6.375 13.2031C5.625 12.5677 4.75 12.25 3.75 12.25V7.5C3.75 6.8125 3.99479 6.22396 4.48438 5.73438C4.97396 5.24479 5.5625 5 6.25 5H11.25C11.25 4.125 11.5521 3.38542 12.1562 2.78125C12.7604 2.17708 13.5 1.875 14.375 1.875C15.25 1.875 15.9896 2.17708 16.5938 2.78125C17.1979 3.38542 17.5 4.125 17.5 5H22.5C23.1875 5 23.776 5.24479 24.2656 5.73438C24.7552 6.22396 25 6.8125 25 7.5V12.5C25.875 12.5 26.6146 12.8021 27.2188 13.4062C27.8229 14.0104 28.125 14.75 28.125 15.625C28.125 16.5 27.8229 17.2396 27.2188 17.8438C26.6146 18.4479 25.875 18.75 25 18.75V23.75C25 24.4375 24.7552 25.026 24.2656 25.5156C23.776 26.0052 23.1875 26.25 22.5 26.25H17.75C17.75 25.2083 17.4219 24.3229 16.7656 23.5938C16.1094 22.8646 15.3125 22.5 14.375 22.5C13.4375 22.5 12.6406 22.8646 11.9844 23.5938C11.3281 24.3229 11 25.2083 11 26.25Z" />
            </svg>
          </span>
          <h6>Extras</h6>
        </li>
      </ul>
    </>
  );
};

export default Stepper;
